/**
 * 存储工具 - 管理不同登录方式的存储隔离
 */

/**
 * 清除普通用户相关存储
 */
export function clearUserStorage() {
  // 清除普通用户相关存储
  localStorage.removeItem('token');
  localStorage.removeItem('account');
  localStorage.removeItem('avatar');
  localStorage.removeItem('userName');
  localStorage.removeItem('vip');
  localStorage.removeItem('vipName');
  localStorage.removeItem('vipDate');
  localStorage.removeItem('uploadimage');
  localStorage.removeItem('userInfo');
  
  // 清除相关的过期时间存储
  const keys = Object.keys(localStorage);
  keys.forEach(key => {
    if (key.endsWith('Expiry')) {
      localStorage.removeItem(key);
    }
  });
  
  // 清除sessionStorage中的普通用户数据
  sessionStorage.removeItem('token');
  sessionStorage.removeItem('account');
  sessionStorage.removeItem('avatar');
  sessionStorage.removeItem('userName');
  sessionStorage.removeItem('vip');
  sessionStorage.removeItem('vipName');
  sessionStorage.removeItem('vipDate');
  sessionStorage.removeItem('uploadimage');
  sessionStorage.removeItem('userInfo');
}

/**
 * 清除admin用户相关存储
 */
export function clearAdminStorage() {
  // 清除admin相关存储
  localStorage.removeItem('admin_token');
  localStorage.removeItem('admin_token_expiry');
  localStorage.removeItem('admin_token_jwt');
  localStorage.removeItem('admin_token_jwt_expiry');
  localStorage.removeItem('admin_user_info');
  localStorage.removeItem('admin_permissions');
  localStorage.removeItem('admin_session');
  
  // 清除sessionStorage中的admin相关数据（如果有）
  sessionStorage.removeItem('admin_token');
  sessionStorage.removeItem('admin_token_jwt');
  sessionStorage.removeItem('admin_user_info');
  sessionStorage.removeItem('admin_permissions');
  sessionStorage.removeItem('admin_session');
}

/**
 * 清除所有用户存储（用于登出）
 */
export function clearAllUserStorage() {
  clearUserStorage();
  clearAdminStorage();
}

/**
 * 在登录前清除其他登录方式的存储
 * @param {string} loginType - 登录类型：'user' 或 'admin'
 */
export function clearOtherLoginStorage(loginType) {
  if (loginType === 'admin') {
    // admin登录前清除普通用户存储
    clearUserStorage();
  } else if (loginType === 'user') {
    // 普通用户登录前清除admin存储
    clearAdminStorage();
  }
}

export default {
  clearUserStorage,
  clearAdminStorage,
  clearAllUserStorage,
  clearOtherLoginStorage
};
